var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 321,
    viewBox: "0 0 321 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3781_25816)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3781_25816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.351 45.9125C285.064 42.6258 279.772 42.6258 276.541 45.9125L229.971 92.4827L92.7672 229.686L42.5761 279.878C39.2895 283.164 39.2895 288.456 42.5761 291.687C44.1916 293.303 46.3641 294.138 48.4809 294.138C50.5978 294.138 52.7703 293.303 54.3858 291.687L102.07 244.003H265.734C269.299 244.003 272.642 241.942 273.812 238.599C274.981 235.257 274.146 231.692 271.36 229.464C271.249 229.296 257.378 214.312 257.378 143.732C257.378 128.302 253.59 113.261 246.237 99.8359L288.351 57.7222C291.637 54.4355 291.637 49.1434 288.351 45.9125ZM240.666 143.732C240.666 188.91 246.126 213.81 251.418 227.291H118.782L233.815 112.258C238.327 122.063 240.722 132.814 240.666 143.732Z",
    fill: "#DCF3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.03 261.049C185.629 259.768 180.95 262.331 179.724 266.787C178.331 271.745 174.488 275.533 169.53 276.981C161.675 279.21 153.431 274.642 151.203 266.787C149.921 262.331 145.298 259.768 140.897 261.049C136.441 262.331 133.878 266.954 135.159 271.355C137.499 279.432 142.791 286.173 150.144 290.239C154.879 292.858 160.116 294.194 165.408 294.194C168.304 294.194 171.257 293.805 174.098 292.969C184.626 289.961 192.759 281.883 195.767 271.299C197.049 266.843 194.486 262.219 190.03 260.994V261.049Z",
    fill: "#DCF3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9044 199.438C86.528 199.438 90.2603 195.706 90.2603 191.083V143.733C90.2603 102.176 124.185 68.6966 165.742 68.5295C176.27 68.5295 186.465 70.702 196.046 75.0471C200.224 76.9411 205.182 75.0471 207.076 70.8691C208.97 66.6355 207.076 61.7333 202.898 59.8393C193.595 55.6614 183.902 53.2103 173.875 52.319V35.1059C173.875 30.4823 170.143 26.75 165.519 26.75C160.895 26.75 157.163 30.4823 157.163 35.1059V52.2633C110.37 56.497 73.6042 95.8811 73.6042 143.733V191.083C73.6042 195.706 77.3365 199.438 81.9601 199.438H81.9044Z",
    fill: "#DCF3F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3781_25816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 321,
    height: 321,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3781_25816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250.677,
    height: 267.5,
    fill: "white",
    transform: "translate(40.125 26.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotifications);
export default __webpack_public_path__ + "static/media/no_notifications.ace5f8304f312784c138042ba0042202.svg";
export { ForwardRef as ReactComponent };